/**
 * WhatsApp coexistence / connect-chooser copy — kept out of enIntegrations
 * so that file does not grow further past the 500-line ceiling.
 */
export const enWhatsAppCoexistence = {
  'meta.waChoose.title': 'Connect WhatsApp',
  'meta.waChoose.subtitle': 'Choose how you want to connect your business number',
  'meta.waChoose.intro':
    'You can keep using WhatsApp Business App on the same number while connecting Cloud API here, or connect a number that is not in the Business App.',
  'meta.waChoose.existing.title': 'Connect Existing WhatsApp Business App',
  'meta.waChoose.existing.body':
    'Already using WhatsApp Business App? Connect your existing business number to our platform while continuing to use WhatsApp Business App.',
  'meta.waChoose.existing.cta': 'Connect Existing Number',
  'meta.waChoose.new.title': 'Connect a New WhatsApp Number',
  'meta.waChoose.new.body':
    'Register a number that is not already in WhatsApp Business App, or one already on Cloud API only.',
  'meta.waChoose.new.cta': 'Connect New Number',
  'meta.waChoose.eligibility.title': 'Before you continue (existing number)',
  'meta.waChoose.eligibility.registered': 'The number must already be registered in WhatsApp Business App.',
  'meta.waChoose.eligibility.device': 'You need access to the phone that has that number.',
  'meta.waChoose.eligibility.appVersion': 'WhatsApp Business App should be updated to a supported version.',
  'meta.waChoose.eligibility.portfolio': 'You need Meta Business Portfolio access for that business.',
  'meta.waChoose.eligibility.metaDecides': 'Meta decides whether the number is eligible during signup — we cannot pre-check it.',
  'meta.waChoose.eligibility.region': 'Your country/region must be supported for coexistence.',
  'meta.waChoose.eligibility.confirm': 'You must be able to confirm with the QR code or access code Meta shows.',
  'meta.waChoose.eligibility.note':
    'If Meta rejects the number, the error from Meta is shown. Do not delete your WhatsApp Business App account as part of this flow.',
  'meta.waChoose.limit.title': 'What coexistence means',
  'meta.waChoose.limit.both': 'WhatsApp Business App and Cloud API can use the same number at once.',
  'meta.waChoose.limit.appFeatures': 'Some WhatsApp Business App features may be limited after connecting.',
  'meta.waChoose.limit.history': 'Supported message history and contacts may synchronize — not every past message is guaranteed.',
  'meta.waChoose.limit.groups': 'Group chats are generally not available through Cloud API.',
  'meta.waChoose.limit.pricing': 'API messaging still follows WhatsApp Business Platform policies and pricing.',
  'meta.waChoose.limit.disconnect': 'Some device or account changes on WhatsApp Business App can disconnect Cloud API.',
  'meta.waChoose.limit.appActive': 'WhatsApp Business App must stay active according to Meta’s requirements.',

  'meta.waCoexistence.badge': 'Connected via WhatsApp Coexistence',
  'meta.waCoexistence.connectionType': 'Connection type',
  'meta.waCoexistence.connectionTypeValue': 'Coexistence (Business App + Cloud API)',
  'meta.waCoexistence.cloudApi': 'Cloud API',
  'meta.waCoexistence.businessApp': 'WhatsApp Business App',
  'meta.waCoexistence.webhooks': 'Webhooks',
  'meta.waCoexistence.historySync': 'History synchronization',
  'meta.waCoexistence.history.pending': 'Pending',
  'meta.waCoexistence.history.in_progress': 'In progress',
  'meta.waCoexistence.history.completed': 'Completed',
  'meta.waCoexistence.history.partial': 'Partially completed',
  'meta.waCoexistence.history.failed': 'Failed',
  'meta.waCoexistence.history.not_shared': 'Not shared',
  'meta.waCoexistence.history.unknown': 'Unknown',
  'meta.waCoexistence.wabaId': 'WABA ID',
  'meta.waCoexistence.phoneNumberId': 'Phone Number ID',
  'meta.waCoexistence.displayNumber': 'Display number',
  'meta.waCoexistence.disconnectHint':
    'To disconnect a coexistence number, follow Meta’s procedure in WhatsApp Business App. Do not use Cloud API deregistration for this number.',
  'meta.waCoexistence.status.ok': 'Connected',
  'meta.waCoexistence.status.fail': 'Needs attention',
} as const;
